module.exports = __webpack_public_path__ + "static/media/embed-black-yellow.e6e873b3.svg";